import { makeStyles } from "@material-ui/core/styles";

export const AboutRegistryJss = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
  },
  gridGroup: {
    marginTop: theme.spacing(4),
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    },
  },
  formGrid: {
    padding: theme.spacing(4),
    backgroundColor: "#FFFFFF",
    border: "rgb(190,190,190) solid 1px",
    borderRadius: "4px"
  },
  formControl: {
    margin: theme.spacing(3),
    '& .MuiFormHelperText-root.Mui-error': {
      textAlign: 'left',
    },
    width: '100%',
  },
  label: {
    '& .MuiFormControlLabel-label': {
      fontSize: '1rem',
    }
  },
  legend: {
    color: theme.palette.black.main,
    '& .MuiFormLabel-root .Mui-error': {
      color: theme.palette.black.main,
    },
    '& .MuiFormLabel-root .Mui-focused': {
      color: theme.palette.black.main,
    },
  }
}));
